module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-flex bg-gray pb-fixed-btn"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "page-state"
  }, [_c('van-tabs', {
    attrs: {
      "swipeable": "",
      "swipe-threshold": 5,
      "line-width": '.6rem'
    },
    on: {
      "click": _vm.tabClick
    },
    model: {
      value: (_vm.tabActive),
      callback: function($$v) {
        _vm.tabActive = $$v
      },
      expression: "tabActive"
    }
  }, _vm._l((_vm.tabList), function(item, $index) {
    return _c('van-tab', {
      key: $index,
      attrs: {
        "title": item.title,
        "name": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex1 posi-rel product-list"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cargo"
  }, [_vm._v("101")]), _vm._v(" "), _c('div', {
    staticClass: "Shortage"
  }, [_vm._v("缺货")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-15 text-el fs-28 color-333"
  }, [_vm._v("山楂糖250g")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "btn click"
  }, [_vm._v("补货")]), _vm._v(" "), _c('div', {
    staticClass: "btn click"
  }, [_vm._v("取货")]), _vm._v(" "), _c('div', {
    staticClass: "btn click"
  }, [_vm._v("开门")]), _vm._v(" "), _c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'exchangeProduct'
        })
      }
    }
  }, [_vm._v("换绑商品")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fixed-bot"
  }, [_c('div', {
    staticClass: "btn click",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("确定补货 "), _c('span', {
    staticClass: "fs-24"
  }, [_vm._v("(补货后，请关门盘点库存)")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d8cc766","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/supplyRecord/latticeSupplyCompare.vue
// module id = yKBA
// module chunks = 51